<template>
  <van-popup v-model="agreementInfo.showAgreement" position="right" class="popup-full agreement-dialog">
    <van-nav-bar title="云客网按天合作协议" fixed></van-nav-bar>
    <section class="main-con">
      <div v-html="agreementInfo.content" class="p15"></div>
    </section>
    <div class="btn-wrap van-hairline--top">
      <van-button @click="agreementInfo.showAgreement = false">我不认同</van-button>
      <van-button @click="agree">同意协议</van-button>
    </div>
  </van-popup>
</template>
<script>
import { confirmAgreement } from '@/api/task.js'
export default {
  name: 'YunkeAgreement',
  props: {
    agreementInfo: Object
  },
  data() {
    return {}
  },
  methods: {
    agree() {
      confirmAgreement({
        agreementId: this.agreementInfo.id
      }).then(res => {
        this.$router.push('/task/publish_first')
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~style/var.less';
.agreement-dialog {
  .main-con {
    position: absolute;
    bottom: 45px;
    top: 45px;
    left: 0;
    right: 0;
    overflow: auto;
    color: #333;
  }
  .btn-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    z-index: 2019;
    background-color: #fff;
    .van-button {
      text-align: center;
      flex: 1;
      border-radius: 0;
      border: 0;
      + .van-button {
        background-color: @c;
        color: #fff;
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Agreement.vue